<template>
  <div class="ma-2" v-if="currentExportBox">
    <v-badge overlap bordered color="error"
      :value="boxContentCount" :content="boxContentCount">
      <v-chip outlined color="primary" @click="displayContent()">
        <v-icon small class="mr-1">
          mdi-archive-outline
        </v-icon>
        {{ currentExportBox ? currentExportBox.name : '' }}
      </v-chip>
    </v-badge>
  </div>
</template>

<script>
export default {
  name: 'NavExportBox',
  computed: {
    boxContentCount () {
      return this.$store.state.exportBoxes.virtualExportBoxContentCount
    },
    currentExportBox () {
      return this.$store.state.exportBoxes.currentExportBox
    }
  },
  methods: {
    displayContent () {
      if (this.$route.name === 'ExportBoxContent') {
        this.$store.dispatch('exportBoxes/refreshExportBoxContent', this.currentExportBox)
      } else {
        this.$router.push({ name: 'ExportBoxContent', params: { exportBox: this.currentExportBox } })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/exportBox/NavExportBox.vue